<template>
  <div class="home-admin">
    <div class="home-ambient" aria-hidden="true">
      <div class="home-ambient__orb home-ambient__orb--1" />
      <div class="home-ambient__orb home-ambient__orb--2" />
      <div class="home-ambient__orb home-ambient__orb--3" />
      <div class="home-ambient__grid" />
    </div>

    <header class="home-hero">
      <p class="home-eyebrow">Estudyoo Admin</p>
      <h1 class="home-title">
        <span class="home-title__line">Panel de control</span>
      </h1>
    </header>

    <div class="home-stack">
      <div
        v-for="(section, sectionIndex) in sections"
        :key="section.id"
        class="home-section"
        :style="{ '--section-i': String(sectionIndex) }"
      >
        <CardPrime class="home-card surface-card">
          <template #title>
            <span class="home-card-title">
              <i :class="`pi pi-${section.titleIcon} home-card-title-icon`" aria-hidden="true" />
              {{ section.title }}
            </span>
          </template>
          <template #content>
            <div class="home-tile-grid">
              <button
                v-for="(a, i) in section.actions"
                :key="a.id"
                type="button"
                :class="['home-tile', a.variant]"
                :style="tileStyle(sectionIndex, i)"
                @click="a.go"
              >
                <span class="home-tile-icon"><i :class="`pi ${a.icon}`" aria-hidden="true" /></span>
                <span class="home-tile-text">{{ a.label }}</span>
                <span class="home-tile-ripple" aria-hidden="true" />
              </button>
            </div>
          </template>
        </CardPrime>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import CardPrime from 'primevue/card';

export default {
  name: 'HomeView',
  components: { CardPrime },
  setup() {
    const router = useRouter();

    const go = (dest) => {
      if (typeof dest === 'string') router.push(dest);
      else router.push(dest);
    };

    const sections = computed(() => [
      {
        id: 'usuarios',
        title: 'Usuarios y comunicación',
        titleIcon: 'users',
        actions: [
          { id: 'au1', label: 'Administrar usuarios', icon: 'pi-users', variant: 'home-tile--primary', go: () => go('/admin-alumno') },
          { id: 'au2', label: 'Asignatura por usuario', icon: 'pi-id-card', variant: 'home-tile--primary', go: () => go('/admin-asignatura') },
          { id: 'au3', label: 'Uso de usuarios', icon: 'pi-chart-bar', variant: 'home-tile--info', go: () => go('/admin-uso') },
          { id: 'au4', label: 'Notificar usuarios', icon: 'pi-bell', variant: 'home-tile--amber', go: () => go('/notificar-alumnos') },
        ],
      },
      {
        id: 'actividades-estudyoo',
        title: 'Plataforma actividades y juegos',
        titleIcon: 'sparkles',
        actions: [
          {
            id: 'ae-hub',
            label: 'Actividades Estudyoo',
            icon: 'pi-sparkles',
            variant: 'home-tile--violet',
            go: () => go({ name: 'estudyoo-hub' }),
          },
        ],
      },
      {
        id: 'operacion',
        title: 'Operación y contenido',
        titleIcon: 'database',
        actions: [
          { id: 'op0', label: 'Monitoreo del servidor', icon: 'pi-chart-line', variant: 'home-tile--info', go: () => go({ name: 'monitoreo-servidor' }) },
          { id: 'op1', label: 'Ingreso masivo de datos', icon: 'pi-database', variant: 'home-tile--teal', go: () => go('/admin-masivo') },
          { id: 'op2', label: 'Capítulos no vigentes', icon: 'pi-book', variant: 'home-tile--teal', go: () => go('/capitulos-no-vigente') },
          { id: 'op3', label: 'Orden capítulos en unidades', icon: 'pi-sort-alt', variant: 'home-tile--teal', go: () => go('/orden-capitulos-en-unidades') },
        ],
      },
      {
        id: 'preguntas',
        title: 'Preguntas y calidad',
        titleIcon: 'question-circle',
        actions: [
          { id: 'pr1', label: 'Reporte imágenes preguntas', icon: 'pi-images', variant: 'home-tile--indigo', go: () => go({ name: 'reporte-imagenes-preguntas' }) },
          { id: 'pr2', label: 'Habilidades (preguntas)', icon: 'pi-bolt', variant: 'home-tile--indigo', go: () => go({ name: 'mantenedor-habilidades' }) },
        ],
      },
      {
        id: 'catalogos',
        title: 'Catálogos',
        titleIcon: 'th-large',
        actions: [
          { id: 'ct1', label: 'Capítulos', icon: 'pi-book', variant: 'home-tile--slate', go: () => go({ name: 'mantenedor-capitulos' }) },
          { id: 'ct2', label: 'Unidades', icon: 'pi-sitemap', variant: 'home-tile--slate', go: () => go({ name: 'mantenedor-unidades' }) },
          { id: 'ct3', label: 'Asignaturas', icon: 'pi-bookmark', variant: 'home-tile--slate', go: () => go({ name: 'mantenedor-asignaturas' }) },
          { id: 'ct4', label: 'Videos', icon: 'pi-video', variant: 'home-tile--slate', go: () => go({ name: 'mantenedor-videos' }) },
          { id: 'ct5', label: 'Contratos', icon: 'pi-file', variant: 'home-tile--violet', go: () => go({ name: 'mantenedor-contratos' }) },
        ],
      },
    ]);

    const tileStyle = (sectionIndex, tileIndex) => ({
      '--section-i': String(sectionIndex),
      '--home-tile-i': String(tileIndex),
    });

    return {
      sections,
      tileStyle,
    };
  },
};
</script>

<style scoped>
.home-admin {
  position: relative;
  z-index: 0;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 0 2.5rem;
  min-height: min(70vh, 900px);
  overflow: hidden;
}

/* —— Fondo atmosférico —— */
.home-ambient {
  position: absolute;
  inset: -2rem -1rem 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.home-ambient__grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(15, 23, 42, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, 0.03) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: linear-gradient(180deg, #000 0%, transparent 85%);
  -webkit-mask-image: linear-gradient(180deg, #000 0%, transparent 85%);
}

.home-ambient__orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(64px);
  opacity: 0.55;
  will-change: transform;
}

@media (prefers-reduced-motion: no-preference) {
  .home-ambient__orb--1,
  .home-ambient__orb--2,
  .home-ambient__orb--3 {
    animation: homeFloat 22s ease-in-out infinite;
  }
  .home-ambient__orb--2 {
    animation-duration: 28s;
    animation-delay: -6s;
  }
  .home-ambient__orb--3 {
    animation-duration: 19s;
    animation-delay: -10s;
  }
}

.home-ambient__orb--1 {
  width: min(420px, 50vw);
  height: min(420px, 50vw);
  top: -12%;
  right: -5%;
  background: radial-gradient(circle at 30% 30%, #38bdf8 0%, #2563eb 45%, transparent 70%);
}

.home-ambient__orb--2 {
  width: min(360px, 45vw);
  height: min(360px, 45vw);
  bottom: 10%;
  left: -8%;
  background: radial-gradient(circle at 70% 60%, #a78bfa 0%, #6366f1 50%, transparent 70%);
  opacity: 0.4;
}

.home-ambient__orb--3 {
  width: 240px;
  height: 240px;
  top: 40%;
  left: 50%;
  transform: translateX(-30%);
  background: radial-gradient(circle, #5eead4 0%, #0d9488 55%, transparent 75%);
  opacity: 0.15;
  filter: blur(48px);
}

/* —— Hero —— */
.home-hero {
  position: relative;
  z-index: 1;
  margin-bottom: 1.75rem;
  padding: 0.5rem 0 0.5rem;
}

@media (prefers-reduced-motion: no-preference) {
  .home-eyebrow {
    animation: homeFadeUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.05s both;
  }
  .home-title {
    animation: homeFadeUp 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
  }
  .home-title::after {
    content: '';
    display: block;
    height: 3px;
    max-width: 4.5rem;
    margin-top: 0.85rem;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--primary-color, #2563eb), #7c3aed, #0d9488);
    background-size: 200% 100%;
    animation: homeShine 3.5s ease-in-out 0.8s infinite;
  }
}

.home-eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--admin-text-muted, #64748b);
  margin: 0 0 0.55rem;
}

.home-title {
  font-size: clamp(1.85rem, 4.5vw, 2.45rem);
  font-weight: 800;
  letter-spacing: -0.035em;
  color: var(--admin-text, #0f172a);
  margin: 0;
  line-height: 1.1;
  font-feature-settings: 'ss01' on, 'case' on;
}

.home-title__line {
  display: inline-block;
  background: linear-gradient(120deg, #0f172a 0%, #1e3a5f 45%, #0f172a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

@supports not (background-clip: text) {
  .home-title__line {
    -webkit-text-fill-color: inherit;
    color: inherit;
  }
}

/* —— Secciones (cards) —— */
.home-stack {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1.35rem;
}

.home-section {
  --section-i: 0;
  position: relative;
}

@media (prefers-reduced-motion: no-preference) {
  .home-section {
    animation: homeSectionRise 0.65s cubic-bezier(0.22, 1, 0.36, 1) backwards;
    animation-delay: calc(0.12s + (var(--section-i) * 0.1s));
  }
}

.home-card :deep(.p-card) {
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.06), 0 12px 32px -8px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: box-shadow 0.35s ease, border-color 0.35s ease, transform 0.35s ease;
}

.home-card :deep(.p-card:hover) {
  border-color: rgba(37, 99, 235, 0.12);
  box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08), 0 20px 48px -12px rgba(37, 99, 235, 0.12);
}

@media (min-width: 900px) {
  .home-card :deep(.p-card:hover) {
    transform: translateY(-1px);
  }
}

.home-card :deep(.p-card-title) {
  font-size: 1.02rem;
  font-weight: 650;
  color: var(--admin-text, #0f172a);
  padding-bottom: 0.2rem;
  letter-spacing: -0.01em;
}

.home-card :deep(.p-card-content) {
  padding-top: 0.45rem;
}

.home-card-title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.home-card-title-icon {
  font-size: 1.1rem;
  color: var(--primary-color, #2563eb);
  opacity: 0.95;
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.home-card :deep(.p-card:hover) .home-card-title-icon {
  transform: scale(1.05) rotate(-2deg);
}

/* —— Tiles —— */
.home-tile-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.8rem;
}

.home-tile {
  --home-tile-i: 0;
  --section-i: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 1.05rem 1.1rem;
  text-align: left;
  border: 1px solid var(--admin-border, rgba(15, 23, 42, 0.08));
  border-radius: 12px;
  background: linear-gradient(180deg, #fcfcfe 0%, #f4f6f8 100%);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--admin-text, #1e293b);
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.34, 1.3, 0.64, 1), box-shadow 0.3s ease, border-color 0.3s ease, background 0.3s ease;
}

@media (prefers-reduced-motion: no-preference) {
  .home-tile {
    animation: homeTileRise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
    animation-delay: calc(0.2s + (var(--section-i) * 0.12s) + (var(--home-tile-i) * 0.04s));
  }
}

@media (max-width: 900px) and (prefers-reduced-motion: no-preference) {
  .home-tile {
    animation-delay: calc(0.1s + (var(--section-i) * 0.1s) + (var(--home-tile-i) * 0.03s));
  }
}

.home-tile:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px -6px rgba(15, 23, 42, 0.14), 0 4px 8px -4px rgba(15, 23, 42, 0.08);
  background: #fff;
  border-color: rgba(15, 23, 42, 0.12);
}

.home-tile:active {
  transform: translateY(-1px);
  transition-duration: 0.12s;
}

.home-tile:focus-visible {
  outline: 2px solid var(--primary-color, #2563eb);
  outline-offset: 3px;
}

.home-tile-ripple {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  transform: translate(50%, -50%);
  transition: width 0.45s ease, height 0.45s ease, opacity 0.5s ease;
  opacity: 0;
  pointer-events: none;
}

.home-tile:hover .home-tile-ripple {
  width: 8rem;
  height: 8rem;
  opacity: 0.5;
  right: -0.5rem;
}

.home-tile-icon {
  position: relative;
  z-index: 1;
  width: 2.55rem;
  height: 2.55rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  font-size: 1.12rem;
  color: #fff;
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 4px 10px -2px rgba(15, 23, 42, 0.2);
}

.home-tile:hover .home-tile-icon {
  transform: scale(1.08) translateY(-1px);
}

.home-tile-text {
  position: relative;
  z-index: 1;
  line-height: 1.38;
}

.home-tile--primary .home-tile-icon {
  background: linear-gradient(140deg, #3b82f6, #1d4ed8 90%);
}

.home-tile--primary {
  border-left: 3px solid #2563eb;
}

.home-tile--info .home-tile-icon {
  background: linear-gradient(140deg, #06b6d4, #0e7490);
}

.home-tile--info {
  border-left: 3px solid #0891b2;
}

.home-tile--amber .home-tile-icon {
  background: linear-gradient(140deg, #f59e0b, #b45309);
}

.home-tile--amber {
  border-left: 3px solid #d97706;
}

.home-tile--teal .home-tile-icon {
  background: linear-gradient(140deg, #14b8a6, #0f766e);
}

.home-tile--teal {
  border-left: 3px solid #0d9488;
}

.home-tile--indigo .home-tile-icon {
  background: linear-gradient(140deg, #6366f1, #4338ca);
}

.home-tile--indigo {
  border-left: 3px solid #4f46e5;
}

.home-tile--slate .home-tile-icon {
  background: linear-gradient(140deg, #64748b, #334155);
}

.home-tile--slate {
  border-left: 3px solid #475569;
}

.home-tile--violet .home-tile-icon {
  background: linear-gradient(140deg, #8b5cf6, #5b21b6);
}

.home-tile--violet {
  border-left: 3px solid #7c3aed;
}

@media (max-width: 576px) {
  .home-tile-grid {
    grid-template-columns: 1fr;
  }
  .home-ambient__orb--3 {
    opacity: 0.08;
  }
}

@media (prefers-reduced-motion: no-preference) {
  @keyframes homeFloat {
    0%,
    100% {
      transform: translate(0, 0) scale(1);
    }
    33% {
      transform: translate(2%, -2%) scale(1.04);
    }
    66% {
      transform: translate(-1.5%, 1.5%) scale(0.98);
    }
  }

  @keyframes homeFadeUp {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes homeSectionRise {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.99);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes homeTileRise {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes homeShine {
    0%,
    100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .home-ambient__orb,
  .home-eyebrow,
  .home-title,
  .home-section,
  .home-tile,
  .home-title::after {
    animation: none !important;
  }
  .home-tile,
  .home-section {
    opacity: 1;
    transform: none;
  }
}
</style>
